import React from 'react';

interface LogoProps {
  className?: string;
}

/** Marca do evento: chama em fundo âmbar. */
const Logo: React.FC<LogoProps> = ({ className = 'w-10 h-10 rounded-xl' }) => (
  <div className={`${className} bg-brand-amber flex items-center justify-center shadow-lg shadow-brand-amber/30 shrink-0`}>
    <svg viewBox="0 0 24 24" className="w-[58%] h-[58%]" fill="white" aria-hidden="true">
      <path d="M12.6 2.2c.3 3.6 4.9 5.6 4.9 10.6a5.5 5.5 0 0 1-11 0c0-2.1.9-3.6 2.2-4.8.1 1.8 1 3 2.2 3.3 1.4-2.9-.6-6 1.7-9.1z" />
    </svg>
  </div>
);

export default Logo;
